<template>
    <div v-if="$store.state.connected" class="help">
        <h1>Aide</h1>
        <h2>Raccourcis sur le dashboard</h2>
        <table class="table">
            <thead class="thead-light">
                <th scope="col" >Touche(s)</th>
                <th scope="col" >Action</th>
            </thead>
            <tbody>
                <tr>
                    <th scope="row">'échap' </th> <td> Ferme les pop up </td>
                </tr>
                <tr>
                    <th scope="row">'entrée', 'a', '+' </th> <td> Démarre une nouvelle saisie pour la journée actuelle </td>
                </tr>
                <tr>
                    <th scope="row">'fleche directionnelle bas'</th> <td> Dans les pop up 'nouvelle saisie' et 'modification' permet de passer du champ 'filtre' à la selection du projet </td>    
                </tr>
                <tr>
                    <th scope="row">'m', 's'</th> <td> Ouvre la pop up de la synthèse du mois </td>    
                </tr>
                
            </tbody>
        </table>
        <h2>Fonctionnement</h2>
        <h3>Pop up nouvelle saisie et modification </h3>
        
        Tous les cotas sont basés sur des journées de 7h. <br>
        L'heure pré-saisie est le temps restant pour complèter la journée. <br>
        
        (H => heures, M => minutes, X => X*6 minutes)
        <ul> 
            <li>H </li>
            <li>HH:MM, H:M, :M, H: </li>
            <li>H.X, .X </li>
        </ul>
        <h3> Synthèse <img alt="Synthèse" src="../assets/stats.png" /></h3>
        <p> Toutes les entêtes sont clicables pour permettre de trier les colonnes </p>
        <p> Il y a un système de pagination losqu'il y a plus de 10 projets répertoriés </p>
    </div>
</template>

<script>
    import router from "../router/index.js";

    export default {
        name: "Help",
        data(){
            return{
            }
        },
        created: function() {
            if (!this.$store.state.connected) {
                router.push('connexion');
            } 
        }
    };
</script>

<style scoped>
    .help{
        text-align: left;
        margin-left: 10px;
    }
    .table{
        width: 50%;
        text-align: left;
    }
    
    h3 img {
        height: 30px;
    }
</style>